'use strict';

module.exports = /*@ngInject*/
function(
    _,
    ApiConfig,
    AnthroConfig,
    ReduxService
) {
    return {
        getConfig() {
            return ReduxService.getState()
                .then((state) => {
                    return state.core.siteConfig.sites[0];
                });
        },

        /**
         * Get the available currencies
         * @return {Object}     $q promise object
         */
        getCurrencies() {
            return ReduxService.getState()
                .then((state) => {
                    return state.core.siteConfig.currencies;
                });
        },

        /**
         * Get the available languages
         * @return {Object}     $q promise object
         */
        getLanguages() {
            return ReduxService.getState()
                .then((state) => {
                    return state.core.siteConfig.sites[0].languages;
                });
        },

        /**
         * Get the preferred language
         * @return {Object}     $q promise object
         */
        getPreferredLanguage() {
            return ReduxService.getState()
                .then((state) => {
                    return state.core.siteConfig.sites[0].defaultLanguage;
                });
        },

        getContextUrl() {
            return ReduxService.getState()
                .then((state) => {
                    return state.core.contextPath;
                });
        }
    };
};
